<div tabindex="=0" (blur)="onTouched()" class="multiselect-dropdown" (clickOutside)="closeDropdown()">
    <div *ngIf="_settings.dataLimit && _data.length > _settings.dataLimit" class="alert alert-info">
        {{_settings.dataLimit}} is the maximum number of viewable results. <br>
        Use Search to further refine your results.
    </div>
    <div [class.disabled]="disabled" *ngIf="!_settings.showChipsInsideDropdown">
        <span tabindex="-1" class="dropdown-btn" (click)="toggleDropdown($event)">
            <i class="fa fa-search"></i>
            <div class="filter-textbox"
                *ngIf="(_data.length>0 || _settings.allowRemoteDataSearch) && _settings.allowSearchFilter">
                <input type="text" aria-label="multiselect-search" [readOnly]="disabled" placeholder={{_placeholder}}
                    [(ngModel)]="filter.text" [disabled]="disabled" (ngModelChange)="onFilterTextChange($event)">
            </div>
            <span *ngIf="!_settings.allowSearchFilter">{{_placeholder}}</span>
        </span>
        <div class="multiselect-reset" (click)="!disabled && resetSelectedList()">
            <span>Reset</span>
        </div>
    </div>
    <div class="dropdown-list" [hidden]="!_settings.defaultOpen && !_settings.alwaysOpen">
        <ul class="item1">
            <li (click)="toggleSelectAll()"
                *ngIf="(_data.length > 0 || _settings.allowRemoteDataSearch) && !_settings.singleSelection && _settings.enableCheckAll && _settings.limitSelection===-1"
                class="multiselect-item-checkbox">
                <input type="checkbox" aria-label="multiselect-select-all" [checked]="isAllItemsSelected()"
                    [disabled]="disabled || isLimitSelectionReached()" />
                <div>{{!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText}}</div>
            </li>
        </ul>
        <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
            <li *ngFor="let item of _data | multiSelectFilter:filter : _settings.dataLimit; let i = index;"
                (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
                <input type="checkbox" aria-label="multiselect-item" [checked]="isSelected(item)"
                    [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
                <div>{{item.text}}</div>
            </li>
            <li class='no-data' *ngIf="_data.length == 0 && !_settings.allowRemoteDataSearch">
                <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
            </li>
        </ul>
    </div>

    <div class="selected-item-container" [hidden]="!_settings.showChipSelection || _settings.showChipsInsideDropdown">
        <ng-container *ngFor="let item of selectedItems;trackBy: trackByFn;let k = index">
            <acl-ngx-chip [text]="item.text" (onClose)="onItemClick($event,item)">
            </acl-ngx-chip>
        </ng-container>
    </div>

    <div [class.disabled]="disabled" class="chips-inside-dropdown" *ngIf="_settings.showChipsInsideDropdown">
        <div tabindex="-1" class="dropdown-btn" (click)="toggleDropdown($event)">
            <ng-container *ngFor="let item of selectedItems;trackBy: trackByFn;let k = index">
                <acl-ngx-chip [text]="item.text" (onClose)="onItemClick($event,item)">
                </acl-ngx-chip>
            </ng-container>
            <div class="select-text">
                Select
            </div>
        </div>
    </div>
</div>